var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[(_vm.readonly)?_c('h3',[_vm._v(_vm._s(_vm.value))]):_c('input',{staticClass:"numberInput",attrs:{"type":"number","readonly":_vm.readonly},domProps:{"value":_vm.value},on:{"input":function($event){return _vm.change($event)}}})])}
var staticRenderFns = []

export { render, staticRenderFns }